import { defineMessages } from "react-intl";

import { node as heartFailureEtiology } from "src/modules/htx/forms/medical-history/heartFailureEtiology";
import { node as summaryReport } from "src/modules/htx/forms/medical-history/summaryReport";
import { node as thoracotomies } from "src/modules/htx/forms/medical-history/thoracotomies";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.medical_history",
		defaultMessage: "Anamnézis"
	}
});

export const node: ParentNode = {
	id: "medicalHistory",
	value: { type: "list", title: messages.title },
	children: [heartFailureEtiology, summaryReport, thoracotomies]
};
